<div class="page traveler">
  <mat-tab-group disableRipple class="dialog-table" mat-stretch-tabs="false">
    <mat-tab label="Lock templates">
      <lock-template-table></lock-template-table>
    </mat-tab>
  </mat-tab-group>
</div>
